export default {
    //  backgroundColor: '#cee4e5',
    fontWeight:'bold'
  }